import BaseCommand from "@/models/api/commands/BaseCommand";

export class AddBookingItemCommand extends BaseCommand {
  CommandName = "AddBookingItem";
  // Command: AddTradeTermToAllParams;TODO
  constructor(sessionId: string, operationId: string /*, params: AddTradeTermToAllParams*/) {
    super(sessionId, operationId);
    // this.Command = params;
  }
}
